import instance from "@/utils/require.js"

// QC报表--表格查询(也可导出)
export function apiProOrderQCReport(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_record/search",
		method: "post",
		data
	})
}

// QC报表--QC日志查看
export function apiQCShowLog(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_record/show_log",
		method: "post",
		data
	})
}

// QC报表--QC日志查看
export function apiAnomalyReport(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_record/anomaly/report",
		method: "post",
		data
	})
}
export function apiAnomalyReportByDays(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_record/anomaly/report/days",
		method: "post",
		data
	})
}
export function apiAnomalyReportByHours(data = {}) {
	return instance({
		url: "/aim/api/v3/qc_record/anomaly/report/hours",
		method: "post",
		data
	})
}
